<template>
  <div
    :id="rootElementId != null && rootElementId !== '' ? rootElementId : undefined"
    class="account-content account-panel account-panel--rice"
  >
    <div class="account-rice-block" data-animate="fade-up">
      <h2 class="account-section-title">Соберите правильный плов</h2>
      <p class="account-rice-block__lead">
        Соберите все 6 казанов и станьте участником розыгрыша приза — кухонной станции!
      </p>
      <div class="account-rice-block__desktop">
        <div class="account-rice-grid">
          <div
            v-for="(game, gi) in wonRiceGamesNormalized"
            :key="gi"
            class="account-rice-item"
          >
            <div
              class="account-rice-item__visual"
              :class="{
                'account-rice-item__visual--won': game.available === 'won',
                'account-rice-item__visual--next': game.available === 'next_available',
                'account-rice-item__visual--lock': game.available === 'not_available',
              }"
            >
              <img
                v-if="game.available === 'won' && game.image"
                :src="game.image"
                :alt="game.title"
                class="account-rice-item__img"
              >
              <img
                v-else-if="game.available === 'next_available'"
                :src="riceGameReady1x"
                :srcset="`${riceGameReady2x} 2x`"
                alt=""
                class="account-rice-item__img account-rice-item__img--placeholder"
              >
              <img
                v-else
                :src="riceGameDisabled1x"
                :srcset="`${riceGameDisabled2x} 2x`"
                alt=""
                class="account-rice-item__img account-rice-item__img--placeholder"
              >
            </div>
            <div class="account-rice-item__title">{{ game.title }}</div>
            <a
              v-if="game.available === 'won'"
              class="button button-transparent account-rice-item__btn"
              role="button"
              :href="riceGameReceiptPdfHref(game)"
              :download="riceGameReceiptPdfDownloadName(game)"
              rel="noopener noreferrer"
              @click.prevent="onRiceReceiptPdfClick(game)"
            >
              Смотреть рецепт
            </a>
            <button
              v-else-if="game.available === 'next_available'"
              type="button"
              :class="riceNextPlayButtonClass(game)"
              :disabled="!riceNextPlayEnabled(game)"
              @click="onRiceNextPlayClick(gi, game)"
            >
              {{ riceNextPlayLabel(game) }}
            </button>
            <button
              v-else
              type="button"
              class="button button-transparent account-rice-item__btn account-rice-item__btn--muted"
              @click="onUploadCheckClick"
            >
              Загрузить чек
            </button>
          </div>
        </div>
      </div>
      <div class="account-rice-block__mobile">
        <Swiper
          class="account-rice-swiper"
          :modules="riceSwiperModules"
          :slides-per-view="1"
          :space-between="16"
          :pagination="accountRiceSwiperPagination"
          :initial-slide="wonRiceSwiperInitialIndex"
          @swiper="onAccountRiceSwiperInit"
        >
          <SwiperSlide v-for="(game, gi) in wonRiceGamesNormalized" :key="'m-' + gi">
            <div class="account-rice-item account-rice-item--slide">
              <div
                class="account-rice-item__visual"
                :class="{
                  'account-rice-item__visual--won': game.available === 'won',
                  'account-rice-item__visual--next': game.available === 'next_available',
                  'account-rice-item__visual--lock': game.available === 'not_available',
                }"
              >
                <img
                  v-if="game.available === 'won' && game.image"
                  :src="game.image"
                  :alt="game.title"
                  class="account-rice-item__img"
                >
                <img
                  v-else-if="game.available === 'next_available'"
                  :src="riceGameReady1x"
                  :srcset="`${riceGameReady2x} 2x`"
                  alt=""
                  class="account-rice-item__img account-rice-item__img--placeholder"
                >
                <img
                  v-else
                  :src="riceGameDisabled1x"
                  :srcset="`${riceGameDisabled2x} 2x`"
                  alt=""
                  class="account-rice-item__img account-rice-item__img--placeholder"
                >
              </div>
              <div class="account-rice-item__title">{{ game.title }}</div>
              <a
                v-if="game.available === 'won'"
                class="button button-transparent account-rice-item__btn"
                role="button"
                :href="riceGameReceiptPdfHref(game)"
                :download="riceGameReceiptPdfDownloadName(game)"
                rel="noopener noreferrer"
                @click.prevent="onRiceReceiptPdfClick(game)"
              >
                Смотреть рецепт
              </a>
              <button
                v-else-if="game.available === 'next_available'"
                type="button"
                :class="riceNextPlayButtonClass(game)"
                :disabled="!riceNextPlayEnabled(game)"
                @click="onRiceNextPlayClick(gi, game)"
              >
                {{ riceNextPlayLabel(game) }}
              </button>
              <button
                v-else
                type="button"
                class="button button-transparent account-rice-item__btn account-rice-item__btn--muted"
                @click="onUploadCheckClick"
              >
                Загрузить чек
              </button>
            </div>
          </SwiperSlide>
        </Swiper>
        <div :id="paginationElementId" class="account-rice-swiper-pagination"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import 'swiper/css/pagination';
import { state } from '@/store';
import riceGameReady1x from '@/assets/img/rice-game/game-ready.png';
import riceGameReady2x from '@/assets/img/rice-game/game-ready@2x.png';
import riceGameDisabled1x from '@/assets/img/rice-game/game-disabled.png';
import riceGameDisabled2x from '@/assets/img/rice-game/game-disabled@2x.png';
import { normalizeWonRiceGamesListForUi } from '@/utils/wonRiceNormalize';
import {
  riceReceiptAbsoluteUrl,
  downloadRiceRecipePdf,
  riceRecipeSafeDownloadName,
  resolveRiceRecipePdfPath,
} from '@/utils/riceRecipePdfDownload';

export default {
  name: 'AccountInteractiveRicePanel',
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    wonRiceGames: {
      type: Array,
      default: () => [],
    },
    /** Корень ответа won-rice: available | all_won | not_available */
    chainAccess: {
      type: String,
      default: 'available',
    },
    /** Уникальный id пагинации Swiper (контейнер ниже слайдера). */
    paginationElementId: {
      type: String,
      default: 'account-rice-swiper-pagination',
    },
    /** Якорь ЛК (#account-interactive); в попапе на главной не передаём, чтобы не дублировать id. */
    rootElementId: {
      type: String,
      default: null,
    },
  },
  emits: ['upload-check'],
  data() {
    return {
      riceSwiperModules: [Pagination],
      riceGameReady1x,
      riceGameReady2x,
      riceGameDisabled1x,
      riceGameDisabled2x,
      accountRiceSwiper: null,
    };
  },
  computed: {
    wonRiceGamesNormalized() {
      return normalizeWonRiceGamesListForUi(this.wonRiceGames);
    },
    wonRiceSwiperInitialIndex() {
      const list = this.wonRiceGamesNormalized;
      const nextIdx = list.findIndex((g) => g.available === 'next_available');
      if (nextIdx !== -1) return nextIdx;
      const firstOpenIdx = list.findIndex((g) => g.available !== 'won');
      return firstOpenIdx === -1 ? 0 : firstOpenIdx;
    },
    accountRiceSwiperPagination() {
      return {
        el: `#${this.paginationElementId}`,
        clickable: true,
      };
    },
  },
  watch: {
    wonRiceSwiperInitialIndex() {
      this.$nextTick(() => this.syncAccountRiceSwiperSlide());
    },
  },
  unmounted() {
    this.accountRiceSwiper = null;
  },
  methods: {
    onAccountRiceSwiperInit(swiper) {
      this.accountRiceSwiper = swiper;
      this.syncAccountRiceSwiperSlide();
    },
    syncAccountRiceSwiperSlide() {
      const sw = this.accountRiceSwiper;
      if (!sw || typeof sw.slideTo !== 'function') return;
      const i = this.wonRiceSwiperInitialIndex;
      if (typeof sw.activeIndex === 'number' && sw.activeIndex !== i) {
        sw.slideTo(i, 0);
      }
    },
    goToRiceGamePage(slotIndex) {
      const n = Number(slotIndex);
      const slot = Number.isFinite(n) ? String(Math.max(1, Math.min(6, Math.floor(n) + 1))) : '1';
      this.$router.push({ path: `/private/game/plov/${slot}/intro` });
    },
    riceNextPlayEnabled(game) {
      if (!game || game.available !== 'next_available') return false;
      if (this.chainAccess !== 'available') return false;
      if (game.playBlocked) return false;
      return state.promoStatus === 'start';
    },
    riceNextPlayLabel(game) {
      if (this.chainAccess === 'all_won') return 'Все призы выиграны';
      if (this.chainAccess === 'not_available') return 'Следующий казан недоступен';
      if (game.playBlocked) return 'Игра недоступна';
      if (state.promoStatus === 'end') return 'Акция завершена';
      if (state.promoStatus === 'not-started' || state.promoStatus === 'future') return 'Скоро';
      if (state.promoStatus !== 'start') return 'Игра недоступна';
      return 'Начать игру';
    },
    riceNextPlayButtonClass(game) {
      const base = 'button account-rice-item__btn';
      if (this.riceNextPlayEnabled(game)) return `${base} button-main`;
      return `${base} button-transparent account-rice-item__btn--muted`;
    },
    onRiceNextPlayClick(slotIndex, game) {
      if (!this.riceNextPlayEnabled(game)) return;
      this.goToRiceGamePage(slotIndex);
    },
    riceGameReceiptPdfHref(game) {
      return riceReceiptAbsoluteUrl(resolveRiceRecipePdfPath(game));
    },
    riceGameReceiptPdfDownloadName(game) {
      return riceRecipeSafeDownloadName(game?.title || '', 'retsept');
    },
    async onRiceReceiptPdfClick(game) {
      const url = this.riceGameReceiptPdfHref(game);
      if (!url) return;
      await downloadRiceRecipePdf(url, game?.title || '');
    },
    onUploadCheckClick() {
      this.$emit('upload-check');
    },
  },
};
</script>
